export default {"src":"/_next/static/media/vaessen.345d6364.svg","height":110,"width":110,"blurWidth":0,"blurHeight":0};